<div class="tabs">
    @for (tab of tabs; let i = $index; track tab) {
        @if (tab?.value != 'draft' || (tab?.value === 'draft' && tab?.access?.includes(role))) {
        <snl-page-tab [isSelected]="(selectedTab == tab?.value) ? true : false" (onPageTabClick)="onSelectTab(tab,i)">{{tab.label}} ({{tab.number_of_records}})</snl-page-tab>
        }
    }
</div>